import React from "react";
import classNames from "classnames";
import { IconProps } from "../type";

export function Edit3Icon({
  className,
  style,
  active,
  color,
  ...props
}: IconProps & { active?: boolean; color?: React.CSSProperties["color"] }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNames(["h-full w-full", className])}
      style={style}
      viewBox='0 0 23 22'
      fill='transparent'
      {...props}
    >
      <path
        d='M16.5 2.00006C16.7626 1.73741 17.0744 1.52907 17.4176 1.38693C17.7608 1.24479 18.1286 1.17163 18.5 1.17163C18.8714 1.17163 19.2392 1.24479 19.5824 1.38693C19.9256 1.52907 20.2374 1.73741 20.5 2.00006C20.7626 2.2627 20.971 2.57451 21.1131 2.91767C21.2553 3.26083 21.3284 3.62862 21.3284 4.00006C21.3284 4.37149 21.2553 4.73929 21.1131 5.08245C20.971 5.42561 20.7626 5.73741 20.5 6.00006L7 19.5001L1.5 21.0001L3 15.5001L16.5 2.00006Z'
        stroke={color ?? "black"}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
